import Collapse from 'react-bootstrap/Collapse';

import styles from 'css/src/components/pricing/PricingFeatureTooltip.module.scss';

import React, { useRef, useState } from 'react';

import Popover, { POPOVER_PLACEMENT } from 'js/src/components/common/ui/Popover';
import { isOnMobileDevice } from 'js/src/libs/mobile-check';

type Props = {
    title: string;
    description: string;
    icon?: string;
    color?: string;
    text: string;
};

const PricingFeatureTooltip: React.FC<Props> = ({
    title,
    description,
    icon = 'info',
    color,
    text,
}) => {
    const [show, setShow] = useState(false);
    const triggerRef = useRef<HTMLSpanElement>(null);
    const isMobile = isOnMobileDevice();
    const iconStyle = color ? { color } : undefined;

    const cardContent = (
        <>
            <span className={styles['card-header']}>
                <span
                    translate="no"
                    className={`material-symbols-outlined ${styles['card-icon']}`}
                    style={iconStyle}
                >
                    {icon}
                </span>
                <span className={styles['card-title']}>{title}</span>
            </span>
            <span className={styles['card-description']}>{description}</span>
        </>
    );

    if (isMobile) {
        return (
            <div className={styles['mobile-wrapper']}>
                <button
                    className={styles['trigger']}
                    onClick={() => setShow((prev) => !prev)}
                    aria-expanded={show}
                >
                    <span className={styles['feature-title']}>{text}</span>
                    <span
                        translate="no"
                        className={`material-symbols-outlined ${styles['chevron']}`}
                    >
                        {show ? 'expand_less' : 'expand_more'}
                    </span>
                </button>
                <Collapse in={show}>
                    <div>
                        <div className={styles['inline-card']}>{cardContent}</div>
                    </div>
                </Collapse>
            </div>
        );
    }

    return (
        <>
            <span
                ref={triggerRef}
                className={styles['feature-title']}
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                {text}
            </span>
            <Popover
                target={triggerRef}
                show={show}
                placement={POPOVER_PLACEMENT.BOTTOM_START}
                rootClose={false}
            >
                <div className={styles['floating-card']}>{cardContent}</div>
            </Popover>
        </>
    );
};

export default PricingFeatureTooltip;
